import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Preloader from "./Include/PreLoader";
import AIBackground from "../functions/AIBackground";
import PandaPickLogo from "../assets/icon.png";
import API_URL from "../functions/config";

const Login = ({ setAuth }) => {

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const [showResend, setShowResend] = useState(false);
    const [resending, setResending] = useState(false);
    const [resendMessage, setResendMessage] = useState("");

    const navigate = useNavigate();


    useEffect(() => {

        const auth = localStorage.getItem("user");

        if (auth) {
            navigate("/dashboard");
            return;
        }

        const empauth = localStorage.getItem("empuser");

        if (empauth) {
            navigate("/");
        }

    }, [navigate]);


    const handleLogin = async (e) => {

        e.preventDefault();

        setError("");


        // Email validation
        if (!email.trim()) {
            setError("Please enter your email");
            return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setError("Please enter a valid email address");
            return;
        }


        // Password validation
        if (!password) {
            setError("Please enter your password");
            return;
        }


        try {

            setLoading(true);


            const response = await fetch(`${API_URL}/login`, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    email: email.trim().toLowerCase(),
                    password
                })

            });


            const result = await response.json();


            console.log("Login Response:", result);


            // Backend error
            if (!response.ok) {

                setError(
                    result.message ||
                    "Login failed"
                );

                if (result.emailNotVerified) {
                    setShowResend(true);
                }

                return;
            }


            // Login successful
            if (result.auth) {

                localStorage.setItem(
                    "user",
                    JSON.stringify(result.user)
                );

                localStorage.setItem(
                    "token",
                     JSON.stringify(result.auth)
                );


                setAuth({
                    type: "owner",
                    user: result.user
                });


                navigate("/dashboard");

                return;
            }


            setError(
                result.message ||
                "Invalid email or password"
            );


        } catch (error) {

            console.error("Login Error:", error);

            setError(
                "Unable to connect to server. Please try again."
            );

        } finally {

            setLoading(false);

        }


    };

    const resendVerification = async () => {

        if (!email.trim()) {
            setError("Please enter your email first");
            return;
        }

        try {

            setResending(true);
            setError("");
            setResendMessage("");

            const response = await fetch(
                `${API_URL}/resend-verification`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({
                        email: email.trim().toLowerCase()
                    })
                }
            );

            const result = await response.json();

            if (!response.ok) {

                setError(
                    result.message ||
                    "Unable to resend verification link"
                );

                return;
            }

            setResendMessage(
                result.message
            );

        } catch (error) {

            console.error(
                "Resend Error:",
                error
            );

            setError(
                "Unable to connect to server"
            );

        } finally {

            setResending(false);

        }
    };


    return (

        <div className="hero-section">

            <AIBackground />

            <div className="form_box">

                <div className="form-group">

                    {loading ? (

                        <Preloader show={loading} />

                    ) : (

                        <>

                            <form onSubmit={handleLogin}>

                                <div className="row justify-content-center g-4">

                                    <div className="text-center">

                                        <img
                                            src={PandaPickLogo}
                                            alt="PandaPick"
                                            className="img-fluid"
                                        />

                                    </div>

                                </div>


                                <h3 className="text-center">

                                    Welcome Back to <b>SignIn</b>

                                </h3>


                                {/* Error */}

                                {error && (

                                    <div
                                        className="alert alert-danger text-center rounded-pill p-2 mt-1"
                                        role="alert"
                                    >
                                        {error}
                                    </div>

                                )}


                                {/* Email */}

                                <input
                                    className="form-field"
                                    type="email"
                                    value={email}
                                    onChange={(e) =>
                                        setEmail(e.target.value)
                                    }
                                    placeholder="Please Enter your Email"
                                    autoComplete="email"
                                />


                                {/* Password */}

                                <input
                                    className="form-field"
                                    type="password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    placeholder="Please Enter your Password"
                                    autoComplete="current-password"
                                />


                                <button
                                    type="submit"
                                    className="btn_main"
                                    disabled={loading}
                                >
                                    Login
                                </button>

                                {resendMessage && (
                                    <div
                                        className="alert alert-success mt-3"
                                        role="alert"
                                    >
                                        {resendMessage}
                                    </div>
                                )}


                                {showResend && (
                                    <div className="text-center mt-3">

                                        <p className="mb-2 text-black">
                                            Didn't receive the verification email?
                                        </p>

                                        <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            onClick={resendVerification}
                                            disabled={resending}
                                        >
                                            {resending
                                                ? "Sending..."
                                                : "Resend Verification Link"}
                                        </button>

                                    </div>
                                )}


                                <p className="text-center text-black mt-3">

                                    Don't have an account?

                                    <br />

                                    <Link to="/signup">
                                        Create a free account
                                    </Link>

                                </p>

                            </form>

                        </>

                    )}

                </div>

            </div>

        </div>

    );
};

export default Login;